import AppHeader from '../AppHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'propose-result',
  created () {
  },
  data () {
    return {
      csvFileName: null,
      canValidate: true,
      contribution: {
        startDate: null,
        endDate: null
      },
      mode: 'all',
      proposeStatus: '',
      adoptStatus: '',
      ranks: [
        { name: '採用検討', value: 'considerating' },
        { name: 'テスト採用', value: 'testing' },
        { name: '正式採用', value: 'adopted' }
      ],
      rankIds: []
    }
  },
  watch: {
    mode (val) {
      if (val === 'all') {
        this.proposeStatus = ''
      } else {
        this.proposeStatus = 'approved'
      }
    },
    proposeStatus (val) {
      if (val === 'approved') {
        this.adoptStatus = 'adopted'
      } else {
        this.adoptStatus = ''
      }
    },
    adoptStatus (val) {
      if (val === 'adopted') {
        this.rankIds = [
          'considerating',
          'testing',
          'adopted'
        ]
      } else {
        this.rankIds = []
      }
    },
    rankIds (val) {
      if (val.length === 0 && this.proposeStatus === 'approved') {
        this.adoptStatus = 'notAdopted'
      }
    }
  },
  computed: {
    ...mapGetters({
      proposes: 'csvProposes'
    }),
    IsAllMode: function () {
      return this.mode === 'all'
    },
    IsRejected: function () {
      return this.proposeStatus === 'rejected'
    },
    IsNotAdopted: function () {
      return this.adoptStatus === 'notAdopted'
    },
    validation: function () {
      let validation = {
        required: !(!!this.contribution.startDate && !!this.contribution.endDate),
        integrity: (!!this.contribution.startDate && !!this.contribution.endDate) &&
                   (this.contribution.startDate > this.contribution.endDate),
        not_input: (!!this.contribution.startDate && !!this.contribution.endDate) &&
                   (this.contribution.startDate <= this.contribution.endDate)
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(key => { validation[key] = true })
      }
      return validation
    },
    isValid () {
      let validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    startDate: function () {
      return this.contribution.startDate.getFullYear() + '-' + ('0' + (this.contribution.startDate.getMonth() + 1)).slice(-2) + '-' + ('0' + this.contribution.startDate.getDate()).slice(-2)
    },
    endDate: function () {
      return this.contribution.endDate.getFullYear() + '-' + ('0' + (this.contribution.endDate.getMonth() + 1)).slice(-2) + '-' + ('0' + this.contribution.endDate.getDate()).slice(-2)
    }
  },
  components: {
    AppHeader
  },
  methods: {
    downloadCsv: function () {
      const self = this
      let data = {
        'start_date': this.startDate,
        'end_date': this.endDate,
        'mode': this.mode,
        'propose_status': this.proposeStatus,
        'adopt_status': this.adoptStatus,
        'adopt_rank': this.rankIds
      }

      const callback = function () {
        self.csvFileName = self.startDate.replace(/-/g, '') + '-' + self.endDate.replace(/-/g, '') + '_' + '提案投稿情報' + '.csv'

        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const mimeType = 'text/csv'
        let csv = 'ステータス,投稿日時,安心,誠実,感動,快適,創造,礼節,想像,感応,表現,挑夢,店舗名,社員名1,社員名2,社員名3,いいね！の数,提案タイトル,提案内容,承認コメント,前回却下理由,前回却下内容,採用日時,採用段階3段階,採用コメント,削除区分\n'

        self.proposes.forEach(function (obj) {
          // ステータス
          if (obj.attributes['propose-status'] === 'approved') {
            csv += '承認' + ','
          } else if (obj.attributes['propose-status'] === 'adopted') {
            csv += '採用' + ','
          } else {
            csv += '却下' + ','
          }
          // 投稿日時
          csv += obj.attributes['contribution-at-format'] + ','
          // 安心
          if (obj.attributes['idea-peace-ming']) {
            csv += obj.attributes['idea-peace-ming'] + ','
          } else {
            csv += '0' + ','
          }
          // 誠実
          if (obj.attributes['idea-sincere']) {
            csv += obj.attributes['idea-sincere'] + ','
          } else {
            csv += '0' + ','
          }
          // 感動
          if (obj.attributes['idea-excitement']) {
            csv += obj.attributes['idea-excitement'] + ','
          } else {
            csv += '0' + ','
          }
          // 快適
          if (obj.attributes['idea-comfortable']) {
            csv += obj.attributes['idea-comfortable'] + ','
          } else {
            csv += '0' + ','
          }
          // 創造
          if (obj.attributes['idea-creation']) {
            csv += obj.attributes['idea-creation'] + ','
          } else {
            csv += '0' + ','
          }
          // 礼節
          if (obj.attributes['idea-civility']) {
            csv += obj.attributes['idea-civility'] + ','
          } else {
            csv += '0' + ','
          }
          // 想像
          if (obj.attributes['idea-imagination']) {
            csv += obj.attributes['idea-imagination'] + ','
          } else {
            csv += '0' + ','
          }
          // 感応
          if (obj.attributes['idea-sympathy']) {
            csv += obj.attributes['idea-sympathy'] + ','
          } else {
            csv += '0' + ','
          }
          // 表現
          if (obj.attributes['idea-expression']) {
            csv += obj.attributes['idea-expression'] + ','
          } else {
            csv += '0' + ','
          }
          // 挑夢
          if (obj.attributes['idea-challenge-dream']) {
            csv += obj.attributes['idea-challenge-dream'] + ','
          } else {
            csv += '0' + ','
          }
          // 店舗名
          if (obj.attributes['shop-name']) {
            csv += self.enquoteForCSV(obj.attributes['shop-name']) + ','
          } else {
            csv += ','
          }
          // 社員名1
          if (obj.attributes['user-name0']) {
            csv += self.enquoteForCSV(obj.attributes['user-name0']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname0']) + ','
          } else {
            csv += ','
          }
          // 社員名2
          if (obj.attributes['user-name1']) {
            csv += self.enquoteForCSV(obj.attributes['user-name1']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname1']) + ','
          } else {
            csv += ','
          }
          // 社員名3
          if (obj.attributes['user-name2']) {
            csv += self.enquoteForCSV(obj.attributes['user-name2']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname2']) + ','
          } else {
            csv += ','
          }
          // いいね！の数
          if (obj.attributes['goods-count']) {
            csv += obj.attributes['goods-count'] + ','
          } else {
            csv += '0' + ','
          }
          // 提案タイトル
          if (obj.attributes['propose-title']) {
            csv += self.enquoteForCSV(obj.attributes['propose-title']) + ','
          } else {
            csv += ','
          }
          // 提案内容
          if (obj.attributes['propose-content']) {
            csv += self.enquoteForCSV(obj.attributes['propose-content']) + ','
          } else {
            csv += ','
          }
          // 承認コメント
          if (obj.attributes['approved-reason-content'] && obj.attributes['propose-status'] === 'approved') {
            csv += self.enquoteForCSV(obj.attributes['approved-reason-content']) + ','
          } else {
            csv += ','
          }
          // 前回却下理由
          if (obj.attributes['reject-reason'] && obj.attributes['propose-status'] !== 'approved') {
            csv += self.enquoteForCSV(obj.attributes['reject-reason']) + ','
          } else {
            csv += ','
          }
          // 前回却下内容
          if (obj.attributes['reject-reason-content'] && obj.attributes['propose-status'] !== 'approved') {
            csv += self.enquoteForCSV(obj.attributes['reject-reason-content']) + ','
          } else {
            csv += ','
          }
          // 採用日時
          if (obj.attributes['adopted-at-format'] && obj.attributes['propose-status'] === 'adopted') {
            csv += self.enquoteForCSV(obj.attributes['adopted-at-format']) + ','
          } else {
            csv += ','
          }
          // 採用段階3段階
          if (obj.attributes['adopt-rank-conversion'] && obj.attributes['propose-status'] === 'adopted') {
            csv += self.enquoteForCSV(obj.attributes['adopt-rank-conversion']) + ','
          } else {
            csv += ','
          }
          // 採用コメント
          if (obj.attributes['adopt-content'] && obj.attributes['propose-status'] === 'adopted') {
            csv += self.enquoteForCSV(obj.attributes['adopt-content']) + ','
          } else {
            csv += ','
          }
          // 削除区分
          if (obj.attributes['deleted-at']) {
            csv += '削除済'
          }
          csv += '\n'
        })
        const blob = new Blob([bom, csv], { type: mimeType })
        const hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL) {
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        }
      }
      self.$store.dispatch('PROPOSE_RESULT_DATA_DOWNLOAD', { data: data, callback: callback })
    },
    onClickCancel: function () {
      this.$router.push({path: '/proposes'})
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { // ",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-result.js